module.exports = __webpack_public_path__ + "img/Wp_2001.4b2ca8b5.png";